<template>
  <div class="page-container">
    <el-row>
      <el-col class="container-right">
        <el-page-header @back="goBack" content="详情页面"> </el-page-header>
        <div class="searchconditions">
          <el-form :model="searchForm" ref="searchForm" inline>
            <el-form-item prop="roleName" label="角色名称">
              <el-input v-model="searchForm.roleName" placeholder="请输入角色名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="cyan" @click="handleSearch"
                >查询</el-button
              ><el-button
                icon="el-icon-refresh"
                type="warning"
                @click="resetForm"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              class="add-button"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增角色</el-button
            >
          </el-col>
        </el-row>
        <el-table :data="rolesList" style="width: 100%" v-loading="loading">
          <el-table-column
            prop="sortId"
            label="排序号"
            align="center"
          ></el-table-column>
          <el-table-column prop="roleName" label="角色名称" align="center">
          </el-table-column>
          <el-table-column prop="" label="所属角色" align="center">
            <template>
              <span>{{ parentName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
          <!-- <el-table-column prop="createUser" label="最后操作人" align="center">
          </el-table-column> -->
          <el-table-column
            prop="createTime"
            label="最后操作时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | getDateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            width="250"
            class="handle-btn"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isMain !== 1"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.isMain !== 1"
                type="warning"
                size="mini"
                icon="el-icon-setting"
                @click="configPower(scope.row)"
                >配置权限</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="handleClose" 
      
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="所属角色" prop="">
          <el-input v-model="parentName" disabled></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model="form.roleName"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sortId">
          <el-input v-model="form.sortId" placeholder="请输入排序号" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="角色配置"
      :visible.sync="showConfig"
      :close-on-click-modal="false"
      @close="handleConfigClose" 
      :modal-append-to-body="true"
    >
      <div>
        <div class="roleInfo">
          {{ roleName }}
        </div>
        <div class="head-container">
          <el-tree
            :data="menuTree"
            :props="defaultProps"
            show-checkbox
            :expand-on-click-node="false"
            ref="navTree"
            node-key="id"
            :default-expand-all="isShowNode"
            :default-checked-keys="navIdList"
            @check="checkboxChange"
          >
            <div class="custom-tree-node tree-list" slot-scope="{ data }">
              <span>{{ data.title }}</span>
              <!-- <el-checkbox-group
                v-model="data.btns"
                v-if="data.children && data.children.length == 0"
                class="btn-checkbox"
              >
                <el-checkbox
                  @change="(checked) => handleMenuBtns(checked, data, item)"
                  :checked="item.checked"
                  v-for="item in data.menuBtns"
                  :label="item.id"
                  :key="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group> -->
            </div>
          </el-tree>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="showConfig = false">取 消</el-button>
        <el-button type="primary" @click="savePowerConfig()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSystemRolesSonCompanyList,
  getAllCompanyNavigation,
  saveSystemRoles,
  updateSystemRoles,
  updateRolesStatus,
  getSystemAllNavList,
  getCompanyPermissionNaviListByRolesId,
  saveCompanyRolesNav,
} from "@/common/api.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      showConfig: false,
      parentName: "",
      parentId: null,
      loading: false,
      //菜单列表
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      // 拥有菜单id列表
      navIdList: [],
      roleId: null,
      roleName: "",
      isShowNode: true,
      searchShow: true,
      dialogConfig: false,
      dialogDetails: false,
      rolesList: [],
      searchForm: {
        companyName: "",
        status: "",
      },
      companyType: null,
      form: {
        roleName: "",
        roleType: "offical",
        sortId: null,
        remark: "",
        parentId: null,
        companyType: null,
      },
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        // sortId: [{ required: true, message: "请输入排序号", trigger: "blur" }],
      },
      //企业类型
      companyTypeList: [
        { id: 2, name: "生产企业" },
        { id: 4, name: "塑业企业" },
        { id: 8, name: "终端门店" },
      ],
      btns: [],
      menuBtns: [],
      menuList: [],
      systemPermissionNaviList: [],
      systemRoleNavigationMenuBtnList: [],
      selectNav: [],
      selectMenu: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    //子集角色列表
    getList(id) {
      var params = {
        parentId: id,
        roleName: this.searchForm.roleName,
      };
      this.loading = true;
      getSystemRolesSonCompanyList(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode !== 200) {
          this.$message.error(res.msg);
        } else {
          this.rolesList = res.data || [];
        }
      });
    },
    // 保存新增/编辑
    saveAddOrEdit() {
      // console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.form.roleId) {
            updateSystemRoles(this.form).then((res) => {
              this.loading = false;
              if (res.errorCode == "200") {
                this.getList(this.parentId);
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveSystemRoles(this.form).then((res) => {
              this.loading = false;
              if (res.errorCode == 200) {
                this.getList(this.parentId);
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },

    // 新增机构
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增角色";
      this.form.companyType = this.companyType;
      this.form.parentId=this.parentId;
    },
    // 编辑机构
    edit(row) {
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑角色";
      this.form = {
        roleName: row.roleName,
        roleType: "offical",
        sortId: row.sortId,
        remark: row.remark,
        roleId: row.roleId,
        parentId:this.parentId,
        companyType: this.companyType,
      };
    },
    // 配置权限
    configPower(row) {
      this.showConfig = true;
      this.roleId = row.roleId;
      this.roleName = row.roleName;
      this.getSystemNavigationId(row.roleId);
    },
    // 监听配置权限dialog
    handleConfigClose() {
      this.$nextTick(() => {
        this.$refs.navTree.setCheckedKeys([]);
      });
    },
    // 获取所有菜单列表
    getAllCompanyNavigation(type) {
      var data = {
        navType: "system",
      };
      getAllCompanyNavigation(data).then((res) => {
        if (res.errorCode == 200) {
          this.menuTree.push(res.data);
          // console.log(this.menuTree);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 该角色拥有的菜单id
    getSystemNavigationId(id) {
      var data = {
        roleId: id,
      };
      var list = [];
      this.selectNav = [];
      this.selectMenu = [];
      getCompanyPermissionNaviListByRolesId(data).then((res) => {
        if (res.errorCode == 200) {
          var dataList = res.data;
          if (dataList && dataList.length > 0) {
            dataList.forEach((item) => {
              list.push(item.id);
              this.selectNav.push({
                roleId: this.roleId,
                naviId: item.id,
                naviName: item.name,
              });
              if (item.btns && item.btns.length > 0) {
                item.btns.forEach((arr) => {
                  this.selectMenu.push({
                    roleId: this.roleId,
                    navigationId: item.id,
                    menuBtnId: arr,
                    sort: "1",
                  });
                });
              }
            });

            console.log(this.selectMenu);
            this.navIdList = list;
            getMenuBtns(this.menuTree);
            function getMenuBtns(array) {
              array.forEach((item) => {
                item.btns = [];
                for (var k in dataList) {
                  if (dataList[k].id == item.id) {
                    item.btns = dataList[k].btns;
                  }
                }
                if (item.children && item.children.length > 0) {
                  getMenuBtns(item.children);
                }
              });
            }
          } else {
            getNav(this.menuTree);
            function getNav(array) {
              array.forEach((item) => {
                item.btns = [];
                if (item.children && item.children.length > 0) {
                  getNav(item.children);
                }
              });
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 节点被点击发生变化
    checkboxChange(data, json) {
      this.selectNav = [];
      var ridsb = this.$refs.navTree
        .getCheckedNodes()
        .concat(this.$refs.navTree.getHalfCheckedNodes());
      if (ridsb.length > 0) {
        ridsb.forEach((item) => {
          var obj = {
            roleId: this.roleId,
            naviId: "",
            naviName: "",
          };
          obj.naviId = item.id;
          obj.naviName = item.title;
          this.selectNav.push(obj);
        });
      }
      var nodeArr = json.checkedNodes;
      var isHaveNode = false;
      nodeArr.forEach((item) => {
        if (item.id == data.id) {
          isHaveNode = true;
        }
      });
      if (!isHaveNode) {
        data.btns = [];
        if (data.children && data.children.length > 0) {
          getNav(data.children);
        }
        function getNav(array) {
          array.forEach((item) => {
            item.btns = [];
            if (item.children && item.children.length > 0) {
              getNav(item.children);
            }
          });
        }
      }
      // console.log(json.checkedNodes);
    },
    // 监听选择按钮
    handleMenuBtns(checked, data, item) {
      var btnId = item.id;
      var navId = data.id;
      if (checked) {
        var ishave = false;
        if (this.selectNav.length > 0) {
          for (var i = 0; i < this.selectNav.length; i++) {
            if (this.selectNav[i].naviId == navId) {
              ishave = true;
              break;
            }
          }
          if (!ishave) {
            this.$message.error("请先选择菜单");
            data.btns = [];
          }
        } else {
          this.$message.error("请先选择菜单");
        }
      }
    },
    // 保存权限配置
    savePowerConfig() {
      console.log(this.menuTree);
      var list = [],
        data = {};
      var ridsb = this.$refs.navTree
        .getCheckedNodes()
        .concat(this.$refs.navTree.getHalfCheckedNodes()); // 获取当前的选中的数据{对象}
      var mentList = [];
      var roleId = this.roleId;
      getMenuList(this.menuTree);
      function getMenuList(array) {
        array.forEach((item) => {
          if (item.btns && item.btns.length > 0) {
            item.btns.forEach((list) => {
              mentList.push({
                roleId: roleId,
                navigationId: item.id,
                menuBtnId: list,
                sort: "",
              });
            });
          }
          if (item.children && item.children.length > 0) {
            getMenuList(item.children);
          }
        });
      }
      if (ridsb.length > 0) {
        ridsb.forEach((item) => {
          var obj = {
            roleId: this.roleId,
            naviId: "",
            naviName: "",
          };
          obj.naviId = item.id;
          obj.naviName = item.title;
          list.push(obj);
        });

        data.roleId = this.roleId;
        data.systemPermissionNaviList = list;
        data.systemRoleNavigationMenuBtnList = mentList;
        saveCompanyRolesNav(data).then((res) => {
          if (res.errorCode == 200 && res.msg == "数据正常") {
            this.showConfig = false;
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请选择需要配置的权限");
      }
    },
    //修改角色状态
    statusChange(row) {
      var department = row.roleName;
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "失效";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              roleId: row.roleId,
              status: row.status,
            };
            updateRolesStatus(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 表单重置
    reset() {
      this.form = {
        roleName: "",
        roleType: "offical",
        sortId: null,
        remark: "",
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    // 查询
    handleSearch() {
      this.getList(this.parentId);
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs["searchForm"].resetFields();
        this.getList(this.parentId);
      });
    },
    goBack() {
      this.$router.replace("/admin/home/companyUserPage");
    },
    close() {
      this.dialogVisible = false;
    },
    isExpand() {
      this.isShowNode = !this.isShowNode;
    },
    //查看配置
    checkConfig() {
      this.dialogConfig = true;
    },
  },
  created() {},
  mounted() {
    var id = (this.parentId = this.$route.query.id);
    this.parentName = this.$route.query.name;
    this.companyType = this.$route.query.companyType;
    if (id) {
      this.getList(id);
      this.getAllCompanyNavigation();
    } else {
      this.$router.replace("/admin/home/companyUserPage");
    }
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .el-row {
    height: 100%;
  }
  .container-right {
    padding: 5px 10px 12px;
    border-radius: 6px;
    background-color: #fff;
    margin-top: 10px;
    .add-button {
      margin: 20px 0 10px 10px;
    }
    .searchconditions {
      background: #fff;
      border-radius: 6px;
      margin-top: 10px;
      padding: 5px 15px 12px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
      .el-form {
        .el-form-item {
          display: inline-block;
          margin-right: 10px;
          vertical-align: top;
          margin: 5px 15px 5px 0px;
          /deep/.el-button {
            padding: 8px 15px;
            font-size: 12px;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .btn-checkbox {
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #13ce66;
      border-color: #13ce66;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      color: #13ce66;
    }
  }
  /deep/.el-input__inner,
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }
  .tree-list {
    font-size: 14px;
    color: #333333;
    font-weight: 600;
    display: table;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  .roleInfo {
    text-align: center;
    padding-bottom: 20px;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
  .el-checkbox-group {
    display: inline-block;
    margin-left: 20px;
    white-space: normal;
    vertical-align: middle;
    width: 78%;
    padding: 6px 0;
  }
  /deep/.el-tree-node__content {
    height: auto;
    min-height: 26px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/rolesManage/companyUserSonPage.vue